/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SalesTotalsbyAmountModule
 * Purpose		: Module for SalesTotalsbyAmount.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { SalesTotalsbyAmountService } from './SalesTotalsbyAmount.service';
import { SalesTotalsbyAmountListComponent } from './SalesTotalsbyAmountList.component';
import { SalesTotalsbyAmountSearchComponent } from './SalesTotalsbyAmountSearch.component';
import { SalesTotalsbyAmountDetailsComponent } from './SalesTotalsbyAmountDetails.component';

import { SalesTotalsbyAmountRoutingModule } from './SalesTotalsbyAmount-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    SalesTotalsbyAmountRoutingModule
  ],
  declarations: [
    SalesTotalsbyAmountListComponent,
	SalesTotalsbyAmountSearchComponent,
	SalesTotalsbyAmountDetailsComponent
  ],
  providers: [
    SalesTotalsbyAmountService
  ]
})

export class SalesTotalsbyAmountModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/SalesTotalsbyAmount/SalesTotalsbyAmount.module.ts